import React, { Fragment, useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { TrashIcon } from 'components/icons';
import IconButton from 'components/shared/IconButton';
import Field from './Field';
import KPIFormatSelect from './KPIFormatSelect';
import KPILeanSelect from './KPILeanSelect';
import KPITypeSelect from './KPITypeSelect';

function KPIFieldset({ name, value, index, removable, onSelect, onKeyChange, onAxisChange, onRemove, options }) {
  const dataset = useWatch({ name });

  useEffect(() => {
    onKeyChange();
  }, [onKeyChange, dataset.key]);

  useEffect(() => {
    onAxisChange();
  }, [onAxisChange, dataset.yAxis]);

  return (
    <Fragment>
      <Field
        name={name}
        label={`KPI ${index + 1}`}
        icon={
          removable && (
            <IconButton
              variant="text"
              color="primary"
              size="x-small"
              onClick={() => onRemove(index)}
              aria-label="Delete"
              data-tip="Delete KPI"
            >
              <TrashIcon />
            </IconButton>
          )
        }
        component={KPITypeSelect}
        onSelect={onSelect}
        options={options}
      />
      <Field name={`${name}.type`} component={KPIFormatSelect} />
      <Field name={`${name}.yAxis`} component={KPILeanSelect} />
    </Fragment>
  );
}

export default KPIFieldset;
